import awsIot from "aws-iot-device-sdk";

export default awsIot;



// WEBPACK FOOTER //
// ./src/components/third-party/AWSIoTData/index.web.js